import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useMemo } from 'react';
import classNames from 'classnames';
import Breadcrumbs from '@availity/breadcrumbs';
import AppIcon from '@availity/app-icon';
import Feedback from '@availity/feedback';
import Spaces, { SpacesLogo, useSpaces, useSpacesContext } from '@availity/spaces';

var PageHeader = function PageHeader(_ref) {
  var payerId = _ref.payerId,
      spaceName = _ref.spaceName,
      spaceId = _ref.spaceId,
      children = _ref.children,
      appName = _ref.appName,
      appAbbr = _ref.appAbbr,
      iconColor = _ref.iconColor,
      branded = _ref.branded,
      crumbs = _ref.crumbs,
      showFeedback = _ref.feedback,
      feedbackProps = _ref.feedbackProps,
      _ref$titleProps = _ref.titleProps,
      titleClassName = _ref$titleProps.className,
      restTitleProps = _objectWithoutPropertiesLoose(_ref$titleProps, ["className"]),
      RenderRightContent = _ref.renderRightContent,
      renderRightClassName = _ref.renderRightClassName,
      component = _ref.component,
      Tag = _ref.tag,
      clientId = _ref.clientId,
      iconSrc = _ref.iconSrc,
      iconAlt = _ref.iconAlt,
      homeUrl = _ref.homeUrl,
      linkTag = _ref.linkTag,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["payerId", "spaceName", "spaceId", "children", "appName", "appAbbr", "iconColor", "branded", "crumbs", "feedback", "feedbackProps", "titleProps", "renderRightContent", "renderRightClassName", "component", "tag", "clientId", "iconSrc", "iconAlt", "homeUrl", "linkTag", "className"]);

  var _useSpaces = useSpaces(spaceId, payerId),
      spaceForSpaceID = _useSpaces[0],
      spaceForPayerID = _useSpaces[1];

  var _ref2 = useSpacesContext() || {},
      spacesIsLoading = _ref2.loading;

  var _space = spaceForSpaceID || spaceForPayerID;

  var payerLogo = null;

  if (payerId) {
    var logoAttrs = {
      spaceId: spaceId,
      payerId: payerId,
      className: 'd-inline-flex',
      skeletonProps: {
        width: 180,
        height: '100%'
      }
    };
    payerLogo = spaceForPayerID || spacesIsLoading ? React.createElement(SpacesLogo, logoAttrs) : React.createElement(Spaces, {
      spaceIds: spaceId ? [spaceId] : undefined,
      payerIds: [payerId],
      clientId: clientId
    }, React.createElement(SpacesLogo, logoAttrs));
  }

  var _spaceName = spaceName || _space && _space.name;

  if (spaceId || spaceName) {
    var url = spaceForSpaceID && spaceForSpaceID.link && spaceForSpaceID.link.url ? spaceForSpaceID.link.url : "/web/spaces/spaces/#/" + spaceId;
    crumbs = [{
      name: _spaceName,
      url: url
    }];
  }

  var feedback = useMemo(function () {
    return React.createElement(Feedback, Object.assign({
      appName: appName,
      className: "d-inline-flex flex-shrink-0 " + (payerId ? 'mx-3' : '')
    }, feedbackProps));
  }, [appName, feedbackProps, payerId]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "d-flex align-items-start flex-shrink-0"
  }, React.isValidElement(crumbs) ? crumbs : React.createElement(Breadcrumbs, {
    crumbs: crumbs,
    active: appName || children,
    homeUrl: homeUrl,
    linkTag: linkTag
  }), component), React.createElement("div", Object.assign({
    className: classNames('page-header page-header-brand d-flex justify-content-between align-items-end', className),
    "data-testid": "page-header"
  }, props), React.createElement(Tag, Object.assign({
    className: classNames('page-header-title page-header-left d-flex align-items-center mb-0', titleClassName),
    "data-testid": "page-header-title"
  }, restTitleProps), !payerId && appAbbr && React.createElement(AppIcon, {
    className: "mr-2",
    "data-testid": "page-header-app-icon",
    color: iconColor,
    branded: branded,
    title: appName,
    src: iconSrc,
    alt: iconAlt
  }, appAbbr), children || React.createElement("h1", {
    className: "mb-0"
  }, appName)), !RenderRightContent ? React.createElement("div", {
    className: "page-header-left d-flex flex-wrap flex-md-nowrap flex-grow align-items-end justify-content-end"
  }, showFeedback && feedback, payerLogo) : React.createElement(RenderRightContent, {
    className: renderRightClassName,
    payerLogo: payerLogo,
    feedback: feedback
  })));
};

PageHeader.defaultProps = {
  tag: 'div',
  // SpaceId and payerId are defaulted to null to prevent `useSpace` from
  // returning a space we may not want
  spaceId: null,
  payerId: null,
  homeUrl: '/public/apps/dashboard',
  titleProps: {},
  renderRightClassName: 'page-header-left d-flex flex-wrap flex-md-nowrap flex-grow align-items-end justify-content-end'
};
export default PageHeader;